import { render, staticRenderFns } from "./GroupRightsTable.vue?vue&type=template&id=6018a294&"
import script from "./GroupRightsTable.vue?vue&type=script&lang=js&"
export * from "./GroupRightsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports